var _defineProperty = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/defineProperty.js");

var _regeneratorRuntime = require("/usr/src/app/www/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var _require = require("@ensdomains/ensjs"),
    ENSJS = _require.default,
    getEnsAddress = _require.getEnsAddress;

var _require2 = require("web3-utils"),
    isAddress = _require2.isAddress;

module.exports = {
  convertENSNames: function () {
    var _convertENSNames = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var ens, inputArgs, methodABI, inputParams, web3, networkId, registryAddress, args, params;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              ens = _ref.ens, inputArgs = _ref.inputArgs, methodABI = _ref.methodABI, inputParams = _ref.inputParams, web3 = _ref.web3, networkId = _ref.networkId;
              registryAddress = ens.registryAddress;

              if (!(inputArgs.length && methodABI)) {
                _context.next = 8;
                break;
              }

              _context.next = 5;
              return this.convertENSArgsNames({
                inputArgs: inputArgs,
                methodABI: methodABI,
                web3: web3,
                registryAddress: registryAddress,
                networkId: networkId
              });

            case 5:
              args = _context.sent;
              _context.next = 9;
              break;

            case 8:
              args = inputArgs;

            case 9:
              if (!inputParams) {
                _context.next = 13;
                break;
              }

              _context.next = 12;
              return this.convertENSParamsNames({
                inputParams: inputParams,
                web3: web3,
                registryAddress: registryAddress,
                networkId: networkId
              });

            case 12:
              params = _context.sent;

            case 13:
              return _context.abrupt("return", {
                args: args,
                params: params
              });

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function convertENSNames(_x) {
      return _convertENSNames.apply(this, arguments);
    }

    return convertENSNames;
  }(),
  getNewENSJS: function getNewENSJS(_ref2) {
    var provider = _ref2.provider,
        registryAddress = _ref2.registryAddress,
        networkId = _ref2.networkId;
    return new ENSJS({
      provider: provider,
      ensAddress: registryAddress || getEnsAddress(networkId)
    });
  },
  resolveNameToAddress: function () {
    var _resolveNameToAddress = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
      var name, provider, registryAddress, networkId, ensjs, message;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              name = _ref3.name, provider = _ref3.provider, registryAddress = _ref3.registryAddress, networkId = _ref3.networkId;
              _context2.prev = 1;
              ensjs = this.getNewENSJS({
                provider: provider,
                registryAddress: registryAddress,
                networkId: networkId
              });
              _context2.next = 9;
              break;

            case 5:
              _context2.prev = 5;
              _context2.t0 = _context2["catch"](1);
              message = "There was a problem initializing the ENS library." + "Please ensure you have the address of the registry set correctly." + " Truffle is currently using ".concat(registryAddress, ".");
              throw new Error("".concat(message, " - ").concat(_context2.t0.message));

            case 9:
              _context2.next = 11;
              return ensjs.name(name).getAddress("ETH");

            case 11:
              return _context2.abrupt("return", _context2.sent);

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this, [[1, 5]]);
    }));

    function resolveNameToAddress(_x2) {
      return _resolveNameToAddress.apply(this, arguments);
    }

    return resolveNameToAddress;
  }(),
  convertENSArgsNames: function convertENSArgsNames(_ref4) {
    var _this = this;

    var inputArgs = _ref4.inputArgs,
        methodABI = _ref4.methodABI,
        web3 = _ref4.web3,
        registryAddress = _ref4.registryAddress,
        networkId = _ref4.networkId;
    if (methodABI.inputs.length === 0) return inputArgs;
    var convertedNames = inputArgs.map(function (argument, index) {
      if (index + 1 > methodABI.inputs.length) {
        return argument;
      } else if (methodABI.inputs[index].type === "address") {
        // Check all address arguments for ENS names
        var argIsAddress = isAddress(argument);
        if (argIsAddress) return argument;
        return _this.resolveNameToAddress({
          name: argument,
          provider: web3.currentProvider,
          registryAddress: registryAddress,
          networkId: networkId
        });
      } else {
        return argument;
      }
    });
    return Promise.all(convertedNames);
  },
  convertENSParamsNames: function () {
    var _convertENSParamsNames = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref5) {
      var _this2 = this;

      var inputParams, web3, registryAddress, networkId, outputParams, newFrom, newAccessList;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              inputParams = _ref5.inputParams, web3 = _ref5.web3, registryAddress = _ref5.registryAddress, networkId = _ref5.networkId;
              outputParams = inputParams;

              if (!(inputParams.from && !isAddress(inputParams.from))) {
                _context4.next = 7;
                break;
              }

              _context4.next = 5;
              return this.resolveNameToAddress({
                name: inputParams.from,
                provider: web3.currentProvider,
                networkId: networkId,
                registryAddress: registryAddress
              });

            case 5:
              newFrom = _context4.sent;
              outputParams = _objectSpread(_objectSpread({}, outputParams), {}, {
                from: newFrom
              });

            case 7:
              if (!(inputParams.accessList && Array.isArray(inputParams.accessList))) {
                _context4.next = 12;
                break;
              }

              _context4.next = 10;
              return Promise.all(inputParams.accessList.map( /*#__PURE__*/function () {
                var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(entry) {
                  var newAddress;
                  return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          if (!(entry && entry.address && !isAddress(entry.address))) {
                            _context3.next = 7;
                            break;
                          }

                          _context3.next = 3;
                          return _this2.resolveNameToAddress({
                            name: entry.address,
                            provider: web3.currentProvider,
                            networkId: networkId,
                            registryAddress: registryAddress
                          });

                        case 3:
                          newAddress = _context3.sent;
                          return _context3.abrupt("return", _objectSpread(_objectSpread({}, entry), {}, {
                            address: newAddress
                          }));

                        case 7:
                          return _context3.abrupt("return", entry);

                        case 8:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                }));

                return function (_x4) {
                  return _ref6.apply(this, arguments);
                };
              }()));

            case 10:
              newAccessList = _context4.sent;
              outputParams = _objectSpread(_objectSpread({}, outputParams), {}, {
                accessList: newAccessList
              });

            case 12:
              return _context4.abrupt("return", outputParams);

            case 13:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function convertENSParamsNames(_x3) {
      return _convertENSParamsNames.apply(this, arguments);
    }

    return convertENSParamsNames;
  }()
};